/**
 * GTA click → dataLayer.
 * Click identity lives in the event name (e.g. col-cart_luba-3-awd, col-filter-drive-type-awd).
 * Price filter uses a fixed event: g--c-col-filter-price-change
 *   with price_min / price_max (numeric strings) plus common fields.
 *
 * Common fields: page_url, button_text, target_url, price_min, price_max.
 *
 * Markup opt-in: click-gta + data-gta + data-gta-push
 * Price: trailing debounce on price-range[data-gta-push], then fixed event above
 *   (empty side → that input's min/max bound, not literal "min"/"max")
 * JS: window.pushGtaEvent(name, { button_text, target_url, price_min, price_max })
 *
 * Idempotent: theme.liquid may inject this file more than once.
 */
(function () {
  'use strict';

  if (window.__gtaEventBound) return;
  window.__gtaEventBound = true;

  var PRICE_DEBOUNCE_MS = 500;
  var priceTimer = 0;
  var lastPriceKey = '';
  var COMMON_KEYS = { page_url: true, button_text: true, target_url: true, price_min: true, price_max: true };

  /**
   * @param {Record<string, unknown>} params
   * @returns {Record<string, string>}
   */
  function compactCommonParams(params) {
    var out = {};
    if (!params) return out;
    Object.keys(params).forEach(function (key) {
      if (!COMMON_KEYS[key]) return;
      var value = params[key];
      if (value == null || value === '') return;
      out[key] = String(value);
    });
    return out;
  }

  /**
   * @param {string} name
   * @param {Record<string, unknown>} [params]
   */
  function pushGtaEvent(name, params) {
    if (!name) return;
    var payload = compactCommonParams(params);
    payload.event = name;
    payload.page_url = payload.page_url || window.location.href;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  window.pushGtaEvent = pushGtaEvent;

  /**
   * @param {Element} el
   * @returns {Record<string, string>}
   */
  function collectParams(el) {
    var params = {};
    var buttonText = el.getAttribute('data-gta-button-text');
    if (!buttonText) buttonText = (el.getAttribute('aria-label') || el.textContent || '').trim();
    if (buttonText) params.button_text = buttonText;
    var targetUrl = el.getAttribute('data-gta-target-url') || el.getAttribute('href') || '';
    if (targetUrl) params.target_url = targetUrl;
    return params;
  }

  /**
   * fromModule in theme.js may suffix `.click-gta.button` names with `__…`.
   * @param {string} raw
   * @returns {string}
   */
  function eventNameFromGta(raw) {
    if (!raw) return '';
    return raw.split('__')[0];
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target && event.target.closest && event.target.closest('[data-gta-push][data-gta]');
      if (!el) return;
      if (el.tagName === 'PRICE-RANGE' || (el.closest && el.closest('price-range[data-gta-push]'))) return;
      var name = eventNameFromGta(el.getAttribute('data-gta') || '');
      if (!name) return;
      pushGtaEvent(name, collectParams(el));
    },
    true
  );

  /**
   * Numeric string from a price input. Empty side uses the input's bound
   * (min attr / 0 for gte; max attr / paired range max for lte) — never "min"/"max" literals.
   * @param {HTMLInputElement|null} input
   * @param {'min'|'max'} side
   * @param {Element} rangeRoot
   * @returns {string}
   */
  function priceToken(input, side, rangeRoot) {
    var raw = input && input.value != null ? String(input.value).trim() : '';
    if (raw !== '') {
      var cleaned = raw.replace(/[^\d.]/g, '');
      if (cleaned) return cleaned;
    }
    if (side === 'min') {
      if (input && input.min !== '' && input.min != null) return String(input.min);
      var fromRange = rangeRoot && rangeRoot.querySelector('.range-price-from');
      if (fromRange && fromRange.min !== '' && fromRange.min != null) return String(fromRange.min);
      return '0';
    }
    if (input && input.max !== '' && input.max != null) return String(input.max);
    var toRange = rangeRoot && rangeRoot.querySelector('.range-price-to');
    if (toRange && toRange.max !== '' && toRange.max != null) return String(toRange.max);
    return '0';
  }

  /**
   * @param {Element} rangeRoot
   */
  function pushPriceFilter(rangeRoot) {
    var gte = rangeRoot.querySelector('[name="filter.v.price.gte"]');
    var lte = rangeRoot.querySelector('[name="filter.v.price.lte"]');
    var priceMin = priceToken(gte, 'min', rangeRoot);
    var priceMax = priceToken(lte, 'max', rangeRoot);
    var name = 'g--c-col-filter-price-change';
    var dedupeKey = name + '|' + priceMin + '|' + priceMax;
    if (dedupeKey === lastPriceKey) return;
    lastPriceKey = dedupeKey;
    // data-gta on <price-range> is opt-in only; event name is fixed (no from-to suffix).
    pushGtaEvent(name, {
      price_min: priceMin,
      price_max: priceMax,
      button_text: priceMin + '-' + priceMax
    });
  }

  function onPriceEvent(event) {
    var rangeRoot =
      event.target && event.target.closest && event.target.closest('price-range[data-gta-push]');
    if (!rangeRoot) return;
    window.clearTimeout(priceTimer);
    priceTimer = window.setTimeout(function () {
      pushPriceFilter(rangeRoot);
    }, PRICE_DEBOUNCE_MS);
  }

  document.addEventListener('input', onPriceEvent, true);
  document.addEventListener('change', onPriceEvent, true);
})();
